import { Link } from "react-router-dom";
import { brand } from "../lib/brand";

export function PrivacyPage() {
  return (
    <main className="legal-page">
      <Link to="/dashboard">← กลับ</Link>
      <h1>นโยบายความเป็นส่วนตัว</h1>
      <p className="legal-meta">ปรับปรุงล่าสุด: 2026-05-05</p>

      <p>
        นโยบายนี้อธิบายว่า {brand.name} ("เรา") เก็บ ใช้ และรักษาข้อมูลส่วนบุคคลของผู้ใช้ ("คุณ")
        ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)
      </p>

      <h2>1. ข้อมูลที่เราเก็บ</h2>
      <ul>
        <li>อีเมลของคุณ: เพื่อสร้างบัญชีและส่งลิงก์เข้าสู่ระบบ</li>
        <li>ชื่อแสดง: ตามที่คุณตั้งเอง</li>
        <li>ประวัติการซื้อคอร์ส: ผ่านระบบของ Stripe</li>
        <li>ความก้าวหน้าการเรียน: ตำแหน่งล่าสุดในวิดีโอ และสถานะเรียนจบ</li>
        <li>เวลา login ล่าสุด: เพื่อตรวจสอบบัญชีไม่ใช้งาน</li>
      </ul>

      <h2>2. วิธีเก็บและประมวลผล</h2>
      <p>
        ข้อมูลของคุณเก็บอยู่บน Google Firebase (Firestore) ในศูนย์ข้อมูลภูมิภาคสิงคโปร์
        ข้อมูลการชำระเงินและบัตรเครดิต <strong>ไม่ได้</strong>เก็บที่เรา
        แต่จัดการโดย Stripe ตามมาตรฐาน PCI DSS
      </p>

      <h2>3. ข้อมูลที่ส่งให้บุคคลที่สาม</h2>
      <ul>
        <li><strong>Stripe</strong>: รับชำระเงิน เก็บข้อมูลบัตรและธุรกรรม</li>
        <li><strong>Bunny Stream</strong>: จัดเก็บและสตรีมวิดีโอบทเรียน</li>
        <li><strong>Google Cloud / Firebase</strong>: โครงสร้างพื้นฐานและฐานข้อมูล</li>
      </ul>
      <p>เราจะไม่ขายข้อมูลของคุณให้บุคคลที่สาม</p>

      <h2>4. ระยะเวลาเก็บข้อมูล</h2>
      <p>
        เก็บไว้ตลอดเวลาที่บัญชีของคุณยัง active หากคุณขอลบบัญชี เราจะลบข้อมูลทั้งหมดภายใน 30 วัน
        ยกเว้นข้อมูลธุรกรรมที่ต้องเก็บตามกฎหมายภาษี (สูงสุด 5 ปี)
      </p>

      <h2>5. สิทธิ์ของคุณตาม PDPA</h2>
      <ul>
        <li><strong>ขอดูข้อมูล</strong>: ทักมาที่อีเมลด้านล่าง เราจะส่งสำเนาภายใน 30 วัน</li>
        <li><strong>ขอแก้ไข</strong>: แก้ไขชื่อแสดงผ่านหน้า /profile หรือทักมาแก้ฟิลด์อื่น</li>
        <li><strong>ขอลบ</strong>: กดปุ่ม "ขอลบบัญชี" ในหน้า /profile หรือทักอีเมล</li>
        <li><strong>ถอนความยินยอม</strong>: ลบบัญชีถือเป็นการถอนความยินยอม</li>
      </ul>

      <h2>6. Cookies และ Analytics</h2>
      <p>
        เราใช้ cookies เฉพาะเท่าที่จำเป็นสำหรับการ login (Firebase Auth)
        Analytics จะเปิดเฉพาะเมื่อคุณกด "ยอมรับ" ที่ banner ตอนเข้าเว็บครั้งแรก
        คุณเปลี่ยนใจได้ทุกเมื่อโดยลบ cookies ในเบราว์เซอร์
      </p>

      <h2>7. ติดต่อเรื่อง Privacy</h2>
      <p>
        ติดต่อ DPO (Data Protection Officer):
        <br />
        อีเมล: <a href={`mailto:${brand.contactEmail}`}>{brand.contactEmail}</a>
      </p>
    </main>
  );
}
